import { Vector2 } from "../../../common/vector2.js";
import { Emitter } from "../emitters/emitter.js";
import { StopBehavior } from "../types/controller_types.js";
import { IBatchConfig } from "../types/core_types.js";
import { InstanceBatch } from "./instance_batch.js";
import { AttributeSize } from "../types/webgl_types.js";

export abstract class EmitterBatch<TEmitter extends Emitter, TLayout extends Record<string, AttributeSize> = any> extends InstanceBatch<TLayout> 
{
  protected emitters: TEmitter[] = [];

  constructor( config: IBatchConfig<TLayout> )
  {
    super( config );
  }

  protected abstract emitInstance( spawn_pos: Vector2, spawn_time: number, emitter: TEmitter ): void;

  protected updateEmitter( emitter: TEmitter, now: number ): void {}
  
  protected onEmitterKillAll(): void {}

  public addEmitter( emitter: TEmitter ): TEmitter
  {
    // Реєструємо onStop: коли емітер зупиняється з ClearParticles або FadeParticles —
    // вбиваємо всі частинки цього емітера через triggerDeathByGroup.
    emitter.onStop = ( behavior, fade ) =>
    {
      const fade_duration = behavior === StopBehavior.FadeInstances ? fade : 0;
      this.triggerDeathByGroup( emitter.id, performance.now(), fade_duration );
    };
    this.emitters.push( emitter );
    return emitter;
  }

  public hasActiveEmitters(): boolean
  {
    return this.emitters.length > 0;
  }

  public getEmitterCount(): number
  {
    return this.emitters.length;
  }

  protected override onUpdate( now: number ): void
  {
    for ( let i = 0; i < this.emitters.length; i++ )
    {
      const emitter = this.emitters[i];
      
      this.updateEmitter( emitter, now );

      if ( emitter.is_active && emitter.duration !== null )
      {
        const age = now - emitter.start_time;
        if ( age >= emitter.duration )
          emitter.stop();
      }

      if ( emitter.is_active )
      {
        // Тегуємо спавн частинок group_id емітера
        this.current_group_id = emitter.id;
        emitter.process( now, ( spawn_pos, spawn_time ) => this.emitInstance( spawn_pos, spawn_time, emitter ) );
        this.current_group_id = 0;
      }
      else
      {
        this.emitters[i] = this.emitters[this.emitters.length - 1];
        this.emitters.pop();
        i--;
      }
    }
  }

  protected override onKillAll(): void
  {
    this.onEmitterKillAll();
    this.emitters.length = 0;
  }
}